<template>
  <div class="live-auth" @click="showHandle()">
  </div>
</template>

<script>
import VConsole from 'vconsole';
import { mapActions } from "vuex";
export default {
  components: {},
  props: {},
  data () {
    return {
      count: 0,
    };
  },
  watch: {},
  computed: {
    query () {
      return this.$route.query;
    },
    channelId () {
      return this.query.channelId;
    },
    userId () {
      return this.query.userId;
    },
  },
  methods: {
    ...mapActions({
      authSign: 'liveModule/authSign',
      getLiveLiveViewer: 'liveModule/getLiveLiveViewer',
    }),
    async liveHandle () {
      if (!this.userId || !this.channelId) {
        let errText = ''
        if (!this.userId) {
          errText = '缺失用户id，确认链接是否正确'
        }
        if (!this.channelId) {
          errText = '缺失直播间id，确认链接是否正确'
        }
        this.$Message.destroy()
        this.$Message.error(errText);
        return;
      }
      let userId = this.userId.replace(/-/g, '_',).toLocaleLowerCase();
      let opt = { userid: this.userId, channelId: this.channelId };
      let re = await this.authSign(opt);
      if (re && re.sign) {
        let url = `https://0c97b022f4.live.polyv.cn/watch/${this.channelId}?userid=${userId}&ts=${re.ts}&sign=${re.sign}`;
        window.location.replace(url);
      } else {
        this.$Message.destroy()
      }
    },
    showHandle () {
      this.count += 1;
      if (this.count > 4) { 
        const vConsole = new VConsole();
      }
    }
  },
  async created () { 
    this.$Message.loading({
      content: "Loading...",
      duration: 0,
    });
    let res = await this.getLiveLiveViewer(this.userId);
    console.log('小程序观众信息：', res);
    this.$Message.destroy();
    if (res) {
      this.liveHandle();
    } else {
      this.$router.replace(`/live-user-reg?userId=${this.userId}&channelId=${this.channelId}`);
    }
  },
  mounted () { }
}

</script>

<style lang="scss" scoped>
.live-auth {
  height: 100vh;
}
</style>
